<div class="w-100 view-item">
    <h4>Sauvegardes</h4>
    <p data-toggle="collapse" data-target="#collapseSave" aria-expanded="false" aria-controls="collapseSave"><i
            class="material-icons">folder</i> Sauvegarde
    </p>
    <div class="collapse" id="collapseSave">
        <p class="simpleindent">
            <i class="material-icons">folder</i> 05-01-2021 (ID = 6476, Proto = 34)
        </p>
        <div class="doubleindent">
            <p data-toggle="collapse" data-target="#collapsePizza" aria-expanded="false" aria-controls="collapsePizza">
                <i class="material-icons">folder</i> Pizza
            </p>
            <div id="collapsePizza" class="collapse tripleindent">
                <p>
                    <i class="material-icons">folder</i> (Moment) Barbecue
                </p>
            </div>
            <p data-toggle="collapse" data-target="#collapseSales" aria-expanded="false" aria-controls="collapseSales">
                <i class="material-icons">folder</i> Promos
            </p>
            <div class="collapse tripleindent" id="collapseSales">
                <p><i class="material-icons">folder</i> Fin de stock</p>
            </div>
            <p data-toggle="collapse" data-target="#collapseConfiguration" aria-expanded="false"
                aria-controls="collapseConfiguration">
                <i class="material-icons">folder</i> Configuration
            </p>
            <div class="collapse tripleindent" id="collapseConfiguration">
                <p><i class="material-icons">folder</i> Configuration du 26-12-2020 01:46:00</p>
            </div>
            <p><i class="material-icons">folder</i> Utilisateurs</p>
            <p><i class="material-icons">folder</i> Alertes</p>
            <p><i class="material-icons">folder</i> Tickets TPE</p>
        </div>
    </div>

</div>
<div class="w-100 view-item">
    <h4>Activation à distance</h4>
    <div class="form-group form-check">
        <input type="checkbox" id="tunnel" name="tunnal" class="form-check-input">
        <label for="tunnel" class="form-check-label">Activer le tunneling</label>
    </div>
</div>
<div class="w-100 view-item">
    <h4>Téléchargement des ressources</h4>
    <a href="">Télécharger l'archive contenant les ressources</a>
</div>